import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/chevron-right.svg'


const _withScopeId = n => (_pushScopeId("data-v-8377b42a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modules-choose" }
const _hoisted_2 = { class: "categories-wrapper row" }
const _hoisted_3 = { class: "category col-lg-6 col-12" }
const _hoisted_4 = { class: "category col-lg-6 col-12" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "text-md" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-takeda",
  src: _imports_0
}, null, -1))

import PageContainer from '@/components/PageContainer.vue'
import CategorieCard from '@/components/Modules-Choice/CategorieCard.vue'
import { useStoreQuizz } from '@/stores/quizz'
import { useStorePuzzle } from '@/stores/puzzle'
import enLocales from '../locales/en'
import { ref } from 'vue'
import ReferencesModal from '@/components/ReferencesModal.vue'
import { moduleChoiceReferences } from '@/data/modulechoice'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const quizzStore = useStoreQuizz()
const puzzleStore = useStorePuzzle()
const referencesModal = ref<InstanceType<typeof ReferencesModal> | null>(null)

function showReferences() {
  referencesModal.value?.show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageContainer, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('moduleChoice.title')), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(CategorieCard, {
              title: _ctx.$t('moduleChoice.quizzTitle'),
              iconName: "chrono",
              "btn-text": _ctx.$t('moduleChoice.quizzCta'),
              link: "/quizz",
              "shrink-button": false,
              onOnGoTo: _cache[0] || (_cache[0] = ($event: any) => (_unref(quizzStore).reset()))
            }, null, 8, ["title", "btn-text"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(CategorieCard, {
              title: _ctx.$t('moduleChoice.puzzleTitle'),
              iconName: "puzzle",
              "btn-text": _ctx.$t('moduleChoice.puzzleCta'),
              link: "/puzzle",
              "shrink-button": false,
              onOnGoTo: _cache[1] || (_cache[1] = ($event: any) => (_unref(puzzleStore).reset()))
            }, null, 8, ["title", "btn-text"])
          ])
        ]),
        _hoisted_5,
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('moduleChoice.indicationTitle1')), 1),
        _createElementVNode("p", {
          innerHTML: _ctx.$t(_unref(enLocales).moduleChoice.indicationDescription1)
        }, null, 8, _hoisted_6),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('moduleChoice.indicationTitle2')), 1),
        _createElementVNode("p", {
          innerHTML: _ctx.$t(_unref(enLocales).moduleChoice.indicationDescription2)
        }, null, 8, _hoisted_7),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('moduleChoice.indicationTitle3')), 1),
        _createElementVNode("p", {
          innerHTML: _ctx.$t(_unref(enLocales).moduleChoice.indicationDescription3)
        }, null, 8, _hoisted_8)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-empty btn-references",
          onClick: showReferences
        }, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('general.seeReferences')), 1),
          _hoisted_10
        ])
      ]),
      _createVNode(ReferencesModal, {
        ref_key: "referencesModal",
        ref: referencesModal,
        references: Object.values(_unref(moduleChoiceReferences))
      }, null, 8, ["references"])
    ]),
    _: 1
  }))
}
}

})